<div class="mb-6">
  <h3 class="text-xl font-bold text-[#1f273b] mb-4">Trading Plans</h3>

  <div class="flex flex-wrap gap-3 text-sm mb-5 text-gray-600">
    <span
      class="bg-gray-100 px-4 py-1.5 rounded-full border border-gray-300 shadow-sm"
    >
      Filing ID:
      <span class="font-semibold text-[#1f273b]">{{ filing.filingId }}</span>
    </span>

    <span
      class="bg-gray-100 px-4 py-1.5 rounded-full border border-gray-300 shadow-sm"
    >
      Issuer:
      <span class="font-semibold text-[#1f273b]">
        {{ filing.asReportedIssuer?.asReportedIssuerName }}
      </span>
    </span>
  </div>
</div>
<div
  class="flex flex-col md:flex-row justify-between items-start md:items-center gap-y-4 gap-x-6 mb-6"
>
  <!-- Follow-up Input + Add Button -->
  <div class="flex items-center gap-3 w-full md:w-auto">
    <input
      type="text"
      autofocus="false"
      [(ngModel)]="followUpComment"
      placeholder="Enter follow-up"
      class="px-4 py-1 border border-gray-300 rounded-md w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-[#1f273b] shadow-sm"
    />
    <button
      class="bg-[#1f273b] text-white py-1 px-5 border border-[#d9d9d9] rounded hover:bg-[#2a334a] transition-all cursor-pointer"
      (click)="addFollowup()"
      [disabled]="!followUpComment.trim()"
    >
      Add
    </button>
  </div>
  <!-- Right: Buttons -->
  <div class="flex flex-wrap gap-2 justify-start xl:justify-end">
    <!-- View Source -->
    <a
      *ngIf="filing?.sourceLink"
      [href]="filing.sourceLink"
      target="_blank"
      class="text-[#002644] hover:text-[#002644] flex items-center gap-2 transition-all duration-200"
      pTooltip="View Source File"
      tooltipPosition="top"
    >
      <i class="pi pi-link text-lg"></i>
      <span class="underline hover:no-underline font-medium">View Source</span>
    </a>

    <!-- Discard -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded bg-[#1f273b] text-white hover:bg-[#2a334a]"
      (click)="discardFiling(filing)"
      pTooltip="Discard Filing"
      tooltipPosition="top"
    >
      Discard
    </button>

    <!-- Validate -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onValidateClick()"
      [disabled]="validatedPlans.length !== filing.tradingPlans?.length"
      [ngClass]="{
        'bg-[#1f273b] text-white hover:bg-[#2a334a] cursor-pointer':
          validatedPlans.length === filing.tradingPlans?.length,
        'bg-white text-gray-800 cursor-not-allowed':
          validatedPlans.length !== filing.tradingPlans?.length
      }"
      [pTooltip]="
        validatedPlans.length !== filing.tradingPlans?.length
          ? 'Check all plans to enable validate'
          : undefined
      "
      tooltipPosition="top"
    >
      Validate
    </button>

    <!-- Edit -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onEditClick()"
      [disabled]="selectedPlans.length === 0"
      [ngClass]="{
        'bg-[#1f273b] text-white hover:bg-[#2a334a] cursor-pointer':
          selectedPlans.length > 0,
        'bg-white text-gray-800 cursor-not-allowed': selectedPlans.length === 0
      }"
      pTooltip="{{
        selectedPlans.length === 0
          ? 'Select at least one row to enable editing'
          : ''
      }}"
      tooltipPosition="top"
    >
      Edit
    </button>

    <!-- Delete -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onDeleteSelectedPlans()"
      [disabled]="
        tradingPlansIdsForDeletion.length === 0 ||
        filing.tradingPlans?.length === 1 ||
        tradingPlansIdsForDeletion.length === filing.tradingPlans?.length
      "
      [ngClass]="{
        'bg-[#1f273b] text-white hover:bg-[#2a334a] cursor-pointer':
          tradingPlansIdsForDeletion.length > 0 &&
          tradingPlansIdsForDeletion.length <
            (filing.tradingPlans?.length ?? 0),
        'bg-white text-gray-800 cursor-not-allowed':
          tradingPlansIdsForDeletion.length === 0 ||
          tradingPlansIdsForDeletion.length ===
            (filing.tradingPlans?.length ?? 0)
      }"
      pTooltip="{{
        tradingPlansIdsForDeletion.length === 0
          ? 'Select at least one row to enable deleting'
          : tradingPlansIdsForDeletion.length === filing.tradingPlans?.length
          ? 'You cannot remove all trading plans. Please uncheck at least one.'
          : ''
      }}"
      tooltipPosition="top"
    >
      Delete
    </button>
  </div>
</div>

<p-table
  [value]="filing.tradingPlans ?? []"
  [paginator]="false"
  [rows]="5"
  [first]="first"
  [(selection)]="selectedPlans"
  dataKey="tradingPlanId"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[5, 10, 25, 50]"
  [expandedRowKeys]="expandedRows"
  (onRowExpand)="onRowExpand($event)"
  (onRowCollapse)="onRowCollapse($event)"
  styleClass="fixed-table"
>
  <ng-template #header>
    <tr>
      <th><p-tableHeaderCheckbox /></th>
      <th></th>
      <!-- Expansion toggle column -->
      <th>PLAN ID</th>
      <th>INSIDER NAME</th>
      <th>INSIDER TYPE</th>
      <th>RELATION</th>
      <th>PLAN ACTION</th>
      <th>Tag</th>
      <th>ADOPTION DATE</th>
      <th>EFFECTIVE DATE</th>
      <th>AMENDMENT DATE</th>
      <th>TERMINATION DATE</th>
      <th>EXPIRATION DATE</th>
      <th>DURATION DAYS</th>
      <th>ACTION</th>
      <th>DELETE</th>
    </tr>
  </ng-template>
  <ng-template #body let-trading let-expanded="expanded">
    <tr [pSelectableRow]="trading">
      <td>
        <p-tableCheckbox [value]="trading" />
      </td>
      <td>
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="trading"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="
            expandedRows[trading.tradingPlanId]
              ? 'pi pi-chevron-down'
              : 'pi pi-chevron-right'
          "
        ></button>
      </td>

      <td class="cell-ellipsis">
        {{ isDynamicId(trading.tradingPlanId) ? "" : trading.tradingPlanId }}
      </td>

      <td class="cell-ellipsis" [pTooltip]=" trading.asReportedInsider?.asReportedReportingEntityName ||trading.asReportedInsider?.asReportedInsiderName"   tooltipPosition="top">
        {{
          trading.asReportedInsider?.asReportedReportingEntityName ||
            trading.asReportedInsider?.asReportedInsiderName
        }}
      </td>
      <td class="cell-ellipsis">
        {{ trading.asReportedInsider?.asReportedReportingEntityType }}
      </td>
      <td
        class="cell-ellipsis"
        [pTooltip]="trading.relationshipToIssuer"
        tooltipPosition="top"
      >
        {{ trading.relationshipToIssuer }}
      </td>

      <td class="cell-ellipsis">
        {{ trading.planAction }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedPlanAction"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
      </td>
      <td class="cell-ellipsis">
        <div class="inline-flex items-center gap-1">
          <button
            pButton
            type="button"
            icon="pi pi-tag"
            class="p-button-rounded p-button-text"
            pTooltip="Add Tags"
            tooltipPosition="top"
            (click)="writeText(trading)"
          ></button>
          <sup
            *ngIf="trading.modifiedFields?.modifiedOther"
            class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >O</sup
          >
        </div>
      </td>
      <td class="cell-ellipsis">
        {{ formatToDateString(trading.adoptionDate) }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedAdoptionDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedAdoptionDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >E</sup
        >
      </td>
      <td class="cell-ellipsis">
        {{ formatToDateString(trading.effectiveDate) }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedEffectiveDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
      </td>
      <td class="cell-ellipsis">
        {{ formatToDateString(trading.amendmentDate) }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedAmendmentDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedAmendedDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >E</sup
        >
      </td>
      <td class="cell-ellipsis">
        {{ formatToDateString(trading.terminationDate) }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedTerminationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedTerminationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >E</sup
        >
      </td>

      <td class="cell-ellipsis">
        {{ formatToDateString(trading.expirationDate) }}
        <sup
          *ngIf="trading.modifiedFields?.modifiedExpirationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
      </td>
      <td class="cell-ellipsis">
        {{ trading.durationDays }}
     
      </td>
      <td>
        <div class="flex">
          <button
            pButton
            type="button"
            icon="pi pi-check"
            class="p-button-rounded p-button-text p-button-success validate-icon-btn"
            (click)="validatePlan(trading)"
            tooltipPosition="top"
            [disabled]="disabledPlans.includes(trading.tradingPlanId)"
            [pTooltip]="
              !disabledPlans.includes(trading.tradingPlanId)
                ? 'Validate'
                : undefined
            "
            [ngClass]="{
              'bg-gray-300 text-gray-500 border-gray-300 cursor-not-allowed':
                disabledPlans.includes(trading.tradingPlanId)
            }"
          ></button>
        </div>
      </td>
      <td>
        <p-checkbox
          [binary]="true"
          [inputId]="'deleteCheckbox-' + trading.tradingPlanId"
          (onChange)="onCheckboxChange(trading.tradingPlanId, $event.checked)"
        ></p-checkbox>
      </td>
    </tr>
  </ng-template>

  <!-- Row expansion content -->
  <ng-template pTemplate="rowexpansion" #expandedrow let-trading>
    <tr>
      <td colspan="12" class="p-0">
        <div class="p-3">
          <h4 class="text-lg font-bold mb-2">Security Breakdowns</h4>
          <p-table [value]="trading.asReportedSecurityBreakdowns">
            <ng-template #header>
              <tr>
                <th>BREAKDOWN ID</th>
                <th>PLAN ID</th>
                <th>SECURITY TYPE</th>
                <th>TRANSACTION TYPE</th>
                <th>TAGS</th>
                <th>Number OF SHARES</th>
                <th>SHARES DESCRIPTION</th>
                <th>NOTIONAL VALUE</th>
                <th>ACTION</th>
              </tr>
            </ng-template>
            <ng-template #body let-security>
              <tr>
                <td>
                  {{ security?.asReportedSecurityBreakdownId }}
                </td>
                <td>
                  {{
                    isDynamicId(security.tradingPlanId)
                      ? ""
                      : security.tradingPlanId
                  }}
                </td>
                <td>
                  {{ security?.asReportedSecurity?.asReportedSecurityType }}
                </td>
<td>
  <div class="space-x-1 flex items-center ">
    <div class="whitespace-nowrap space-x-1" >
      <span>
        {{ security.transactionType }}
      </span>
      <sup
        class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
         *ngIf="getStringForTransactionTags(security.securityBreakdownTags)"
      >
        {{
          getStringForTransactionTags(
            security.securityBreakdownTags
          )
        }}
      </sup>
        <sup
        *ngIf="trading.modifiedFields?.modifiedTransactionType"
        class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
      >
        M
      </sup>
    </div>
    <div class="flex items-center">
      <select
        [ngModel]="security.selectedTransactionType ?? security.transactionType"
        (ngModelChange)="onSelectionChange(security, $event)"
        class="border p-1 rounded"
      >
        <option value="BUY">Buy</option>
        <option value="SELL">Sell</option>
      </select>
    
    </div>
  </div>
</td>
                <td>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-tag"
                    class="p-button-rounded p-button-text"
                    pTooltip="Add Tags"
                    tooltipPosition="top"
                    (click)="AddTags(security)"
                  ></button>
                </td>

                <td>{{ security.numberOfShares |  number:'1.0-0'  }}  <sup
          *ngIf="trading.modifiedFields?.modifiedNumberOfShares"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        ></td>
                <td>
                  {{ security.sharesDescription }}
                </td>
                <td>{{ security.notionalValue }}</td>
                <td>
                  <div class="flex">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger"
                      pTooltip="Remove"
                      tooltipPosition="top"
                      (click)="removeSecurityBreakdown(security)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmDialog key="trading-confirm"></p-confirmDialog>
<p-confirmDialog key="discardFiling"></p-confirmDialog>
<p-toast></p-toast>
